export default "__VITE_ASSET__DFtZMKTq__"